module.exports = __webpack_public_path__ + "static/ibrahim-rifath-oLVV_o45GIA-unsplash-222f4562453b10dde25f499f07cd8754.png";